import { styled } from "@mui/system";
import { FONT_SIZE_SM, FONT_WEIGHT_NORMAL, LINE_HEIGHT_SM } from "../config/styles";
import { colors } from "../config/colors";

export const InfoLabel = styled("span")({
  fontSize: FONT_SIZE_SM,
  fontFamily: "Open Sans, sans-serif",
  fontWeight: FONT_WEIGHT_NORMAL,
  lineHeight: LINE_HEIGHT_SM,
  color: colors.nonActive,
});
